/* screentitle:
 *
 * Hoist clearing screentitle up outside of questions
 *
 * Author: Niels Giesen
 * Copyright 2019 Berkeley Bridge
 *
 */
(function ($, win, doc) {
  $(function () {
    var $screentitle = $(".p-screentitle");

    if ($screentitle.length > 0)
      $(doc).on("bb:postHandleData", function (event, data) {
        if (data && data.groups) {
          var group = data.groups.find(function (group) {
            return group.screenmode === "clear";
          });
          if (group) $screentitle.text(group.screentitle || "");
        }
      });
  });
})(jQuery, window, document);
